import { LazyLoadImage } from 'react-lazy-load-image-component'
import logo from './logo.png'
const Logo = (props: { size: number }) => {
    return (
        <LazyLoadImage
            alt={'image'}
            height={props.size || 54}
            src={logo}
            width={props.size || 54}
            effect="opacity"
            className="lazy-load-image"
            style={{
                cursor: "pointer",
            }}
            wrapperProps={{

                // If you need to, you can tweak the effect transition using the wrapper style.
                style: { objectFit: "contain", borderRadius: '4px', overflow: 'hidden' },
            }}
        />
    )
}

export default Logo